/**
 * @generated SignedSource<<d026577e3aa6f6534494bbeeae0c4ebf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EventCapacityType = "ATTENDEES" | "GROUPS";
export type EventChargeStaffControl = "ADMIN_ONLY" | "SELECTABLE";
export type EventMemberControl = "HIDDEN" | "SELECTABLE" | "VISIBLE";
export type EventPrimaryChargeType = "PER_PERSON" | "PER_SIGN_UP";
export type FormQuestionTarget = "GROUP" | "PLAYER";
export type FormQuestionType = "BOOLEAN" | "CHECKBOXES" | "EMAIL" | "GHIN_NUMBER" | "LONG_TEXT" | "MULTIPLE_CHOICE" | "NAME" | "PHONE_NUMBER" | "TEXT" | "TOGGLE" | "TRANSPORTATION";
export type QuestionVisibility = "NONE" | "OPTIONAL" | "REQUIRED";
import { FragmentRefs } from "relay-runtime";
export type useInitializeEventSignUpProcess_event$data = {
  readonly allowedGroupSizes: ReadonlyArray<number | null | undefined>;
  readonly capacityType: EventCapacityType | null | undefined;
  readonly eligibleWindowsForCharges: ReadonlyArray<{
    readonly charges: {
      readonly edges: ReadonlyArray<{
        readonly memberControl: EventMemberControl;
        readonly node: {
          readonly chargeRuleSet: {
            readonly chargeRules: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly billingId: string;
                  readonly description: string | null | undefined;
                  readonly duration: number | null | undefined;
                  readonly id: string;
                  readonly price: number;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly displayDescription: string | null | undefined;
            readonly displayName: string | null | undefined;
            readonly id: string;
          };
          readonly id: string;
        } | null | undefined;
        readonly staffControl: EventChargeStaffControl;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly eventSeries: {
    readonly facility: {
      readonly club: {
        readonly supportsPublic: boolean;
      } | null | undefined;
    };
  };
  readonly formConfiguration: {
    readonly formQuestionConfigurations: {
      readonly count: number;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly description: string | null | undefined;
          readonly enabled: boolean;
          readonly guestVisibility: QuestionVisibility;
          readonly id: string;
          readonly memberVisibility: QuestionVisibility;
          readonly placeholder: string | null | undefined;
          readonly prompt: string;
          readonly shortName: string | null | undefined;
          readonly target: FormQuestionTarget;
          readonly type: FormQuestionType;
          readonly values: ReadonlyArray<string | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id: string;
  } | null | undefined;
  readonly hasWaitlist: boolean;
  readonly id: string;
  readonly maxGuestCount: number;
  readonly maxMemberCount: number;
  readonly memberSignUpProxyAllowed: boolean | null | undefined;
  readonly minGuestCount: number;
  readonly minMemberCount: number;
  readonly primaryChargeType: EventPrimaryChargeType | null | undefined;
  readonly primaryRegistrationChargeTypes: {
    readonly count: number;
  } | null | undefined;
  readonly signUpWindows: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly charges: {
          readonly edges: ReadonlyArray<{
            readonly memberControl: EventMemberControl;
            readonly node: {
              readonly chargeRuleSet: {
                readonly chargeRules: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly billingId: string;
                      readonly description: string | null | undefined;
                      readonly duration: number | null | undefined;
                      readonly id: string;
                      readonly price: number;
                    } | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
                readonly displayDescription: string | null | undefined;
                readonly displayName: string | null | undefined;
                readonly id: string;
              };
              readonly id: string;
            } | null | undefined;
            readonly staffControl: EventChargeStaffControl;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly spotsAvailable: number | null | undefined;
  readonly " $fragmentType": "useInitializeEventSignUpProcess_event";
};
export type useInitializeEventSignUpProcess_event$key = {
  readonly " $data"?: useInitializeEventSignUpProcess_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"useInitializeEventSignUpProcess_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventSignUpWindowChargesConnection",
    "kind": "LinkedField",
    "name": "charges",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EventSignUpWindowChargesEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "memberControl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "staffControl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EventRegistrationChargeType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChargeRuleSet",
                "kind": "LinkedField",
                "name": "chargeRuleSet",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayDescription",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChargeRuleConnection",
                    "kind": "LinkedField",
                    "name": "chargeRules",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChargeRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ChargeRule",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "duration",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "price",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "billingId",
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useInitializeEventSignUpProcess_event",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxGuestCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxMemberCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minGuestCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minMemberCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowedGroupSizes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberSignUpProxyAllowed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasWaitlist",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "capacityType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spotsAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supportsPublic",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormConfiguration",
      "kind": "LinkedField",
      "name": "formConfiguration",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "FormQuestionConfigurationConnection",
          "kind": "LinkedField",
          "name": "formQuestionConfigurations",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "FormQuestionConfigurationEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormQuestionConfiguration",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "enabled",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "guestVisibility",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "memberVisibility",
                      "storageKey": null
                    },
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "placeholder",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "prompt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "shortName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "target",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "values",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryChargeType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventRegistrationChargeTypeConnection",
      "kind": "LinkedField",
      "name": "primaryRegistrationChargeTypes",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSignUpWindowConnection",
      "kind": "LinkedField",
      "name": "signUpWindows",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSignUpWindowEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventSignUpWindow",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v3/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "eligibleWindowsForCharges",
      "args": null,
      "concreteType": "EventSignUpWindow",
      "kind": "LinkedField",
      "name": "clientEligibleSignUpWindows",
      "plural": true,
      "selections": (v3/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "b8fd29903570e857ec8a67b33b5d4607";

export default node;
